import React, {Component} from 'react';
import firebase from '../data/firebase.js';
import ListMaker from '../helpers/listMaker';

class Expertise extends Component {
  constructor() {
    super();
    this.state = {
      items: []
    }
  }
  componentDidMount() {
    const itemsRef = firebase.database().ref().child('expertise');
    itemsRef.on('value', (snapshot) => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item.id,
          title: items[item].title,
          intro: items[item].intro,
          expertise: items[item].list
        });
      }
      this.setState({
        items: newState
      });
    });
  }

  render() {
    return (
      <section className="container">
        {this.state.items.map((item, i) => {
          return (
            <div key={i}>
              <h1>{item.title}</h1>
              <h2>{item.intro}</h2>
              <hr/>
              <div className="align-left-top">
                <ListMaker list={item.expertise}></ListMaker>
              </div>
            </div>
          )
        })}
        <video data-html5-video="" preload="metadata" playsinline="playsinline" src="blob:https://www.resortcams.com/6cb116d6-225f-4a45-9c32-195b88db54f6"></video>
      </section>
    );
  }
}

export default Expertise;